// Base needed scripts (paths taken from package .json)
var modernizr							= require('modernizr');
var headjs								= require('headjs');
var $									= require('jquery');
var jquerymigrate						= require('jquerymigrate');
var momentjs							= require('momentjs');
var sweetalert							= require('sweetalert');
var slick 								= require('slick');
var fancybox 							= require('fancybox');
var fancyboxThumbs						= require('fancyboxThumbs');
var lazyload 							= require('lazyload');
var lazyloadbg 							= require('lazyloadbg');
var scrollto 							= require('scrollto');
var sumoselect 							= require('sumoselect');
var doubletaptogo						= require('doubletaptogo');

// Initializers, domIinitializers, smoothState defined
var initializeScripts 					= require('./bundle/functions/initializeScripts');
var DOMinitializers 					= require('./bundle/functions/DOMinitializers');
